<template>
    <div class="space-y-4">
        <UFormGroup label="Subject" required>
            <UInput
                :model-value="modelValue?.subject ?? ''"
                @update:model-value="patch({ subject: $event })"
                size="xl"
            />
        </UFormGroup>
        <UFormGroup label="HTML Body" required>
            <UTextarea
                :model-value="modelValue?.html ?? ''"
                @update:model-value="patch({ html: $event })"
                :rows="12"
                autoresize
                :ui="{ base: 'font-mono text-sm' }"
            />
        </UFormGroup>
        <p class="text-xs text-gray-400">
            Merge tags: &#123;&#123;first_name&#125;&#125;, &#123;&#123;last_name&#125;&#125;, &#123;&#123;full_name&#125;&#125;, &#123;&#123;policy_holder&#125;&#125;
        </p>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: any }>()
const emit = defineEmits<{ 'update:modelValue': [any] }>()

function patch(partial: Record<string, any>) {
    emit('update:modelValue', { ...(props.modelValue ?? {}), ...partial })
}
</script>
